import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatNumber } from '../../utils/numbersFormatting';

interface LowBalanceProps {
  balance?: number;
}

export default function LowBalance({ balance = 0 }: LowBalanceProps) {
  const { t } = useTranslation();
  const minutesBalance = Math.floor(balance / 60);

  return (
    <div className="hidden lg:flex gap-2">
      <div className="text-red-400 flex items-center gap-1">
        <svg
          className="w-4 h-4 text-red-400"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
        <span className="whitespace-nowrap text-sm font-[NapsterSans]">
          {balance === 0 ? (
            t('credits.outOfCredits')
          ) : (
            <>{t('credits.lowBalanceMin', { count: formatNumber(minutesBalance) })}</>
          )}
        </span>
      </div>
      <Link
        to="/pricing"
        className="bg-white hover:bg-white/90 transition-colors duration-200 text-black px-3 py-1 rounded-md text-xs font-medium font-[NapsterSans] whitespace-nowrap">
        <span className="whitespace-nowrap">{t('credits.buyCredits')}</span>
      </Link>
    </div>
  );
}
